import { Component, Input, OnInit } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { DrawerPanelService } from '@ui-core/services/drawer-panel/drawer-panel.service';

@Component({
  selector: 'panel-panic-button',
  templateUrl: './panel-panic-button.component.html',
  styleUrls: ['./panel-panic-button.component.scss'],
})
export class PanelPanicButtonComponent {
  @Input() cards: any[] = [];
  searchTerm = '';

  constructor(private drawerPanelService: DrawerPanelService) { }

  get icon() {
    return Icon;
  }

  get filteredCards(): any[] {
    const term = this.searchTerm.trim().toLowerCase();
    const sortedCards = [...this.cards].sort((a, b) => {
      const idA = Number(a?.id) || 0;
      const idB = Number(b?.id) || 0;
      return idB - idA;
    });

    if (!term) {
      return sortedCards;
    }
    return sortedCards.filter(card => {
      return Object.values(card || {}).some(value => {
        if (value == null) {
          return false;
        }
        return value.toString().toLowerCase().includes(term);
      });
    });
  }

  openModal(card: any): void {
    this.drawerPanelService.collapseDrawer(true);
    card?.cardMapLink?.markerDispatcher.next(
      card.cardMapLink.markerModel
    );
  }

  formatText(text: string): string {
    if (!text) return '';
    const lower = text.toLowerCase();
    const  format= lower.charAt(0).toUpperCase() + lower.slice(1);
    return format
  }

  splitDateTime(dateTimeString: string): { date: string; time: string } {
    if (!dateTimeString) {
      return { date: '', time: '' };
    }

    const originalDate = new Date(dateTimeString);
    if (isNaN(originalDate.getTime())) {
      return { date: '', time: '' };
    }

    // TODO FIX GMT+7
    originalDate.setHours(originalDate.getHours() - 7);

    const year = originalDate.getFullYear();
    const month = String(originalDate.getMonth() + 1).padStart(2, '0');
    const day = String(originalDate.getDate()).padStart(2, '0');
    const hours = String(originalDate.getHours()).padStart(2, '0');
    const minutes = String(originalDate.getMinutes()).padStart(2, '0');
    let seconds = String(originalDate.getSeconds()).padStart(2, '0');

    // ensure seconds string is at most two characters long
    if (seconds.length > 2) {
      seconds = seconds.slice(0, 2);
    }

    const date = `${year}-${month}-${day}`;
    const time = `${hours}:${minutes}:${seconds}`;

    return { date, time };
  }

}
